import { render, staticRenderFns } from "./ci-addresses-table.vue?vue&type=template&id=3ac44e8d&scoped=true&"
import script from "./ci-addresses-table.vue?vue&type=script&lang=js&"
export * from "./ci-addresses-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac44e8d",
  null
  
)

export default component.exports